export default class MultipleChoiceData {
    /**
     * 
     * @param {string} dialogId 
     * @param {string} situationId 
     * @param {string[]} optionIds 
     * @param {string} skill 
     * @param {string} behaviour 
     * @param {number} timeToAnswer - in msecs 
     */
    constructor(episodeId, dialogId, situationId, optionIds, skill, behaviour, timeToAnswer) {
        this.episodeId = episodeId;
        this.dialogId = dialogId;
        this.situationId = situationId;
        this.optionIds = optionIds;
        this.skill = skill;
        this.behaviour = behaviour;
        this.timeToAnswer = timeToAnswer;
    }
}
